import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import {
    reactive,
    watch,
    computed,
    ref,
  } from "vue";
  import useVuelidate from "@vuelidate/core";
  import {
    email,
    helpers,
    required,
    numeric,
    minLength,
    not,
    sameAs,
  } from "@vuelidate/validators";
  import { HolderType } from "@/enums/InitialHoldHolderType";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import store from "@/store";
  import { eventTracking } from "@/helpers/googleAnalyticsEventTracking";
  import {
    EventActionName,
    EventByAction,
    EventByCategory,
    EventLabelByName,
  } from "@/types/EventTracking";
  const PLEASE_SELECT = "Please select";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUsModal',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
    lot: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  emits: ["send"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const userId = computed(() => {
    return store.state?.user?.data?._id;
  });
  const emits = __emit;
  const formLoad = ref(false);
  const props = __props;
  const formFields = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
    postcode: "",
    holderType: PLEASE_SELECT as HolderType | string,
  };
  let form = reactive(Object.assign({}, formFields));
  const rules = {
    firstName: { required },
    lastName: { required },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
    email: { required, email },
    postcode: { required, numeric, minLength: minLength(4) },
    holderType: {
      required,
      validValue: helpers.withMessage(
        "Please select a valid option",
        not(sameAs(PLEASE_SELECT))
      ),
    },
  };

  watch(
    () => props.isOpen,
    (value) => {
      if (value) {
        formLoad.value = true;
        onClose();
        fillForm();
      }
    }
  );

  const v$ = useVuelidate(rules, form);

  function onClose() {
    clearForm();
    resetVuelidateErrors(v$);
  }
  async function submitForm() {
    v$.value.$touch();
    const isValid = await v$.value.$validate();

    if (!isValid) {
      return;
    }

    const { email, ...rest } = form;
    const data = {
      email: email.toLowerCase(),
      ...rest,
    };

    if (props.lot) {
      data.lotTitle = props.lot.lotId.title;
      data.lotId = props.lot.lotId._id;
    }

    convertToLead();
    emits("send", data);
  }
  function clearForm() {
    Object.assign(form, formFields);
  }

  const fillForm = () => {
    if (userId.value) {
      store
        .dispatch("user/getUser", userId.value)
        .then((res) => {
          form.firstName = res.data.firstName;
          form.lastName = res.data.lastName;
          form.phone = res.data.phone;
          form.email = res.data.email;
        })
        .finally(() => {
          formLoad.value = false;
        });
    } else {
      formLoad.value = false;
    }
  };

  const convertToLead = () => {
    const { lot } = props;
    const eventLabelByName = lot
      ? EventLabelByName.CONTACT_US
      : EventLabelByName.MAKE_ENQUIRY;

    const estateById = lot?.estateId || "Not estate selected";

    eventTracking({
      actionsName: EventActionName.CONVERT_TO_LEAD,
      eventByCategory: EventByCategory.LEAD_CONVERSION,
      eventLabelByName,
      eventByAction: EventByAction.CLICK,
      estateById,
    });
  };

const __returned__ = { userId, emits, formLoad, props, PLEASE_SELECT, formFields, get form() { return form }, set form(v) { form = v }, rules, v$, onClose, submitForm, clearForm, fillForm, convertToLead, Modal, DropDown, reactive, watch, computed, ref, get useVuelidate() { return useVuelidate }, get email() { return email }, get helpers() { return helpers }, get required() { return required }, get numeric() { return numeric }, get minLength() { return minLength }, get not() { return not }, get sameAs() { return sameAs }, get HolderType() { return HolderType }, get resetVuelidateErrors() { return resetVuelidateErrors }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, get store() { return store }, get eventTracking() { return eventTracking }, get EventActionName() { return EventActionName }, get EventByAction() { return EventByAction }, get EventByCategory() { return EventByCategory }, get EventLabelByName() { return EventLabelByName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})